import React, { FunctionComponent } from 'react';
import { withRouter } from 'react-router-dom';
import { compose } from 'recompose';
import withStyles from 'react-jss';

import { ClassProp, WithRouterProps } from 'helpers/types';
import { useUserMgmt } from 'components/UserMgmt/UserMgmt.context';

import InternalOverview from './scenes/InternalOverview';
import ExternalOverview from './scenes/ExternalOverview';
import Tier3Overview from './scenes/Tier3Overview';

import { MerchantOverviewProvider } from './MerchantOverview.context';

type Props = WithRouterProps & {
  classes: ClassProp<typeof styles>;
};

const styles = {
  container: {
    width: '100%',
    marginTop: '2.25rem !important',
    justifyContent: 'center !important',
  },
  keyMetricGraphsExternal: {
    marginTop: '5rem !important',
  },
  keyMetricGraphs: {
    marginTop: '9.45rem',
  },
  quickLook: {
    marginBottom: '0.9285625rem',
  },
};

const displayExternalOverview = (isTier3: boolean) => {
  if (isTier3) return <Tier3Overview />;

  return <ExternalOverview />;
};

const MerchantOverview: FunctionComponent<Props> = ({ location }) => {
  const { isExternalUser, isInternalUser, isTier3 } = useUserMgmt();

  return (
    <MerchantOverviewProvider location={location}>
      {isInternalUser && <InternalOverview />}
      {isExternalUser && displayExternalOverview(isTier3)}
    </MerchantOverviewProvider>
  );
};

export default compose<Props, Props>(
  withRouter,
  withStyles(styles as any),
)(MerchantOverview);
